export default [
  {
    path: "domains",
    name: "domains",
    component: (): Promise<any> => import(/* webpackChunkName: "webmaster:domains" */ "@/views/Webmaster/DomainsView.vue")
  }
];
